// /admin (layout) — noindex, mounts AdminLayout which renders children via <Outlet />.
import { createFileRoute } from "@tanstack/react-router";
import AdminLayout from "@/components/AdminLayout";

export const Route = createFileRoute("/admin")({
  head: () => ({
    meta: [
      { title: "Admin | Fora da Rota" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: AdminLayout,
});
